import type { PayCashierMethodOption } from "./CashierType";
import {
  ENTERPRISE_INSUFFICIENT_TAG,
  ENTERPRISE_NOT_OPENED_TAG,
  ENTERPRISE_NOT_OPENED_TOAST,
} from "./CashierConfig";

const INSUFFICIENT_HINT_KEY = "余额不足";

export function isEnterprisePayMethod(method: PayCashierMethodOption): boolean {
  return method.code === "enterprise";
}

export function isEnterpriseInsufficientHint(hint: string): boolean {
  return hint.includes(INSUFFICIENT_HINT_KEY);
}

/** 企业余额不可用时的角标文案；可用时返回 null */
export function resolveEnterpriseMethodTag(method: PayCashierMethodOption): string | null {
  if (!isEnterprisePayMethod(method) || method.enabled) {
    return null;
  }
  const hint = method.disabledHint?.trim() ?? "";
  if (isEnterpriseInsufficientHint(hint)) {
    return ENTERPRISE_INSUFFICIENT_TAG;
  }
  return ENTERPRISE_NOT_OPENED_TAG;
}

export function resolveEnterpriseDisabledToast(method: PayCashierMethodOption): string {
  const hint = method.disabledHint?.trim();
  if (hint) {
    return hint;
  }
  return ENTERPRISE_NOT_OPENED_TOAST;
}

/** 未开通企业时仍可点击以展示说明；仅微信支付等保持原生 disabled */
export function isCashierMethodClickableWhenDisabled(method: PayCashierMethodOption): boolean {
  return isEnterprisePayMethod(method) && !method.enabled;
}
